import { useRef, useState } from 'react'
import { Card, Accordion } from 'react-bootstrap'
import { GroupSelect } from 'GroupSelect'
import SpinButton from 'SpinButton'
import { useSettings } from 'Settings'

const element_options = [
	{ value : "solar", label : "Solar Cell"},
	{ value : "teg", label : "TEG"}
]

const limit = (min, max, value, set_lstate, gstate) => {
	set_lstate(value)

	if (!Number.isNaN(parseFloat(value))) {
		if (min <= value && max >= value) {
			gstate.setValue(value)
		}
	}
}

const General = ({ minOpenVoltageRef, updatePinMin }) => {

	const [settings] = useSettings()
	const hps = settings['harvester power supervisory']

	const [mov, setMOV] = useState(hps['minimum open voltage'].value)
	const [imax, setIMAX] = useState(hps['Imax'].value)

	const onMinOpenVoltageChange = (e) => {
		limit(1, 1000, e.target.value, setMOV, hps['minimum open voltage'])
		updatePinMin()
	}

	return (
		<Accordion.Item eventKey="0">
			<Accordion.Header>General</Accordion.Header>
			<Accordion.Body>
				<GroupSelect
					options={element_options}
					name="Harvesting Element"
					value={hps['harvesting element'].value}
					onChange={(v) => hps['harvesting element'].setValue(v.value)}
				/>
				<SpinButton
					ref={minOpenVoltageRef}
					name="Minimum Open Voltage"
					unit="mV"
					min="1"
					max="1000"
					step="1"
					value={mov}
					onChange={onMinOpenVoltageChange}
				/>
				<SpinButton
					name="Imax"
					unit="mA"
					min="0.1"
					max="45"
					step="0.1"
					value={imax}
					onChange={(e) => limit(0.1, 45, e.target.value, setIMAX, hps['Imax'])}
				/>
			</Accordion.Body>
		</Accordion.Item>
	)
}

const Harvester = ({ hrvCheckLvlRef, updatePinMin }) => {

	const [settings] = useSettings()
	const hps = settings['harvester power supervisory']

	const [hrv_check_lvl, setHrv_check_lvl] = useState(hps['hrv_check_lvl'].value)
	const [v_hrv_min, setV_hrv_min] = useState(hps['v_hrv_min'].value)

	const onHrvCheckLvlChange = (e) => {
		updatePinMin()
		limit(1, 16, e.target.value, setHrv_check_lvl, hps['hrv_check_lvl'])
	}

	return (
		<Accordion.Item eventKey="2">
			<Accordion.Header>Harvester</Accordion.Header>
			<Accordion.Body>
				<SpinButton
					name="v_hrv_min"
					unit="V"
					min="0.073"
					max="4.672"
					step="0.073"
					value={v_hrv_min}
					onChange={(e) => limit(0.073, 4.672, e.target.value, setV_hrv_min, hps['v_hrv_min'])}
				/>
				<SpinButton
					ref={hrvCheckLvlRef}
					name="hrv_check_lvl"
					unit="μA"
					min="1"
					max="16"
					step="1"
					value={hrv_check_lvl}
					onChange={onHrvCheckLvlChange}
				/>
			</Accordion.Body>
		</Accordion.Item>
	)
}

const Pin = ({ pinMin }) => {

	const [settings] = useSettings()
	const hps = settings['harvester power supervisory']
	const [pin_max, setPin_max] = useState(hps['pin max'].value)

	return (
		<Accordion.Item eventKey="3">
			<Accordion.Header>Pin</Accordion.Header>
			<Accordion.Body>
				<SpinButton
					ref={pinMin}
					name="Pin Min"
					unit="nW"
					disabled
					defaultValue="200"
				/>
				<SpinButton
					name="Pin Max"
					unit="mW"
					min="0.1"
					max="100"
					step="0.1"
					value={pin_max}
					onChange={(e) => limit(0.1, 100, e.target.value, setPin_max, hps['pin max'])}
				/>
			</Accordion.Body>
		</Accordion.Item>
	)
}

export default function HarvesterPowerSupervisory() {
	const minimumOpenVoltage = useRef()
	const hrvCheckLvl = useRef()
	const pinMin = useRef()

	function updatePinMin() {
		const min_open_voltage = Math.max(1, Math.min(1000, minimumOpenVoltage.current.value))
		const hrv_check_lvl = Math.max(1, Math.min(16, hrvCheckLvl.current.value))
		pinMin.current.value = min_open_voltage * hrv_check_lvl
	}


	return (
		<Card className="mb-3">
			<Card.Body>
				<Card.Title>Harvester Power Supervisory</Card.Title>
				<Accordion alwaysOpen>
					<General minOpenVoltageRef={minimumOpenVoltage} updatePinMin={updatePinMin} />
					<Harvester hrvCheckLvlRef={hrvCheckLvl} updatePinMin={updatePinMin} />
					<Pin pinMin={pinMin} />
				</Accordion>
			</Card.Body>
		</Card>
	)
}
